module.exports = __webpack_public_path__ + "img/triple-pearl-galaxy-villa.392d20fa.png";